'use client';

import { useState, useEffect } from 'react';
import { useLocale } from './useLocale';

const DEFAULT_EUR_SEK_RATE = 11.50;

/**
 * Fetches the EUR/SEK exchange rate from the API.
 * Only fetches when the site is in EUR mode (.me domain).
 * Returns the rate (SEK per EUR) or the default fallback.
 */
export function useExchangeRate(): number {
  const { currency } = useLocale();
  const [rate, setRate] = useState(DEFAULT_EUR_SEK_RATE);

  useEffect(() => {
    if (currency !== 'EUR') return;
    const apiUrl = process.env.NEXT_PUBLIC_API_URL || 'https://api.autofrance.se/api';
    fetch(`${apiUrl}/exchange-rate`)
      .then((res) => res.ok ? res.json() : null)
      .then((data) => {
        if (data?.eur_sek_rate) setRate(Number(data.eur_sek_rate));
      })
      .catch(() => {});
  }, [currency]);

  return rate;
}
